export const IS_PRODUCTION = process.env.APP_ENV === 'production'


